/**
 * Scoring Module
 *
 * Client-side exports for founder self-assessment (heuristic scoring)
 * and AI scoring integration.
 *
 * IMPORTANT: The investor-facing scoring methodology is stored
 * server-side in `scoring_config` (service_role only). These
 * client-side modules contain only heuristic rules for founder
 * quick assessment and type definitions. No proprietary weights,
 * rubrics, or formulas are exposed here.
 */

// NOTE: scoring domain types live in `./types` and are imported directly
// (`@/lib/scoring/types`) or via the `@/lib/state` re-export. They are NOT
// re-exported here — `./methodology` already owns an `EvidenceLevel` in this
// barrel's namespace, so `export * from './types'` would collide.
export * from './methodology';
export * from './rules';
export * from './calculator';
export * from './recommendations';

// AI Scoring — pure converters (Phase 30). Stateless (no store, no React), so
// they are safe to re-export from this pure barrel. The live scoring flow that
// consumes them is `@/lib/state/score-store` (`triggerAIScoring`).
export {
  profileToScoreInput,
  aiScoreToScoreCriteria,
  estimateScoringCost,
} from './ai-scoring';
